import { FC } from 'react';
import { CapacityTabProps } from './CapacityTabProps';
import { ESTABLISHMENT_TYPE } from '../ProjectTypeSelect/utils';
import CloseCapacityForm from './CloseCapacityForm';
import ProjectCapacityForm from './ProjectCapacityForm';

const CapacityTab: FC<CapacityTabProps> = ({ tabType }) => {
  switch (tabType) {
    case ESTABLISHMENT_TYPE.CLOSE:
      return <CloseCapacityForm />;
    default:
      return <ProjectCapacityForm tabType={tabType} />;
  }
};

export default CapacityTab;
